import React, { Component } from 'react';
import { Form, Select, Radio, Modal, Input, Spin, message } from 'antd';
import '../../../static/css/index.css'
import { fetchJob, addJob } from '../../../apis/api'
import debounce from 'lodash/debounce';

const formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
};
const { Option } = Select;

class AddJob extends Component {
  constructor(props) {
    super(props);
    this.fetchJob = debounce(this.fetchJob, 1000);
    this.state={
        access_token:'',
        job_options:[],
        fetching:false
    }
  }

  componentDidMount(){

    this.setState({access_token:sessionStorage.getItem('access_token')},()=>{
        if(this.props.visible){
            
        }
    })

  }

  
  componentWillReceiveProps(nextProps) { 
    if(nextProps.visible&&nextProps.visible!==this.props.visible){
        
    }
  }

  onChange = e => {
    
    this.setState({
        job_options: [],
    },()=>{
        this.props.form.setFieldsValue({job_type:undefined})
    });
  };

  fetchJob = value => {
    let _this=this,level=this.props.form.getFieldValue('level');
    const { access_token } = this.state;
    let params={
        access_token:access_token,
        name:value,
        level:level
    }
    if(level&&value){
      this.setState({ job_options: [], fetching: true });
      fetchJob(params).then( (data)=> {
        if(data.code === 0){

            let job_options=data.content;
            _this.setState({ job_options, fetching: false });

        }else{
            message.error(data.message); 
        }
      });
    }else if(level){
        this.setState({ job_options: [] });

    }else{
        message.warning('请先选择层级！');
    }
  }

  // 点击取消按钮
  handleCancel = (e) => {
    this.setState({
        job_options:[],
        fetching:false
    },()=>{
        this.props.form.resetFields();
        this.props.cancelModal();
    });
  }

  // 点击确定按钮
  handleOk = (e) => {
    let _this=this,arr=[];
    const { access_token } = this.state;
    _this.props.form.validateFields((err, values) => {
      if(err) {
          console.log('submit error:' ,err);
      }else {
        values.access_token=access_token;
        values.role_uuid=_this.props.role_uuid;
        values.job_type.map(item=>{
            let obj={
                level:values.level,
                job_type:item.label
            }
            arr.push(obj)
        })
        values.job_json=JSON.stringify(arr);
        delete values.level;
        delete values.job_type;
        addJob(values).then( (data)=> {
            if(data.code===0){

                message.success('按岗位授权成功！');
                _this.handleCancel();
                _this.props.getJobList();//更新列表

            }else{
                    
                message.error(data.message);
        
            }
        });
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { visible, role_name } = this.props;
    const { fetching, job_options } = this.state;

    return (

       <div>

        <Modal
          title='按岗位授权'
          visible={visible}
          maskClosable={false}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="确定"
          cancelText="取消"
        >

            <Form className='addJob_form'>

                <Form.Item label="角色名称" {...formItemLayout}>
                    <Input value={role_name} disabled/>
                </Form.Item>

                <Form.Item label="层级" {...formItemLayout}>
                    {getFieldDecorator('level', {
                        initialValue:'',
                        rules: [{ required: true, message: '请选择层级!' }]
                    })(
                        <Radio.Group onChange={this.onChange}>
                            <Radio value={1}>总部</Radio>
                            <Radio value={2}>区域</Radio>
                            <Radio value={3}>城市</Radio>
                            <Radio value={4}>项目</Radio>
                        </Radio.Group>
                    )}
                </Form.Item>

                <Form.Item label="岗位" {...formItemLayout}>
                    {getFieldDecorator('job_type', {
                        initialValue:undefined,
                        rules: [{ required: true, message: '请选择岗位!' }]
                    })(
                        <Select mode="multiple" labelInValue allowClear showSearch optionFilterProp='children' placeholder='请选择岗位' notFoundContent={fetching ? <Spin size="small" /> : null} onSearch={this.fetchJob} filterOption={false}>
                        {job_options&&job_options.length&&job_options.map((opt,index)=>{
                            return(
                            <Option key={index}>{opt.job_type}</Option>
                            )
                        })}
                        </Select>
                    )}
                </Form.Item>

            </Form>
        </Modal>
             
       </div>
    );
  }
}

AddJob = Form.create({
   
})(AddJob);
export default AddJob;



// WEBPACK FOOTER //
// ./src/page/Privilege/components/addJob.js